module.exports = __webpack_public_path__ + "img/parada_bus.255de428.svg";